import React from "react";

export default function MiniaturePreview ({item, link, onClick}) {
    const linkStyle = {
        position:"absolute", 
        right:"20px", 
        bottom:"90px", 
        width:"30%",
        boxSizing:"border-box",
        cursor: link ? "pointer":"inherit"
    }

    function OnClickEvent(e)
    {
        e.preventDefault();

        if(onClick)
            onClick(link);
    }

    return(
        <div style={linkStyle} onClick={(e)=>OnClickEvent(e)}>
            <div style={{height:"35px", borderRadius:"10px", backgroundColor:"var(--black-color-90)",
                margin:"0px 10px 0px 10px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                    <h1 style={{margin:"5px 0px", fontSize:"110%", fontFamily:"FuturaNewDemi", 
                    fontWeight:"100", color:"var(--font-color-yellow)"}}>
                        {item.title}
                    </h1>
                    <h2 style={{margin:"5px 0px", fontSize:"110%", fontFamily:"FuturaNewBook", 
                    fontWeight:"100", color:"var(--font-color-white)", marginLeft:"10px"}}>
                        {item.subtitle}
                    </h2>
            </div>

            <div style={{width:"100%"}}>
                    <img src={item.image} style={{width:"100%", margin:"0px", padding:"0px",
                border:"solid var(--miniature-preview-inner)", borderRadius:"15px",
                borderTop:"0px", boxShadow:"0px 0px 0px 3px var(--miniature-preview)",
                aspectRatio:"16/9"}} />
             </div>
        </div>
    );
}